import { useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useOCR = () => {
  const [loading, setLoading] = useState(false);

  const extractData = useCallback(async (file, docType) => {
    if (!file) return null;

    setLoading(true);
    try {
      const reader = new FileReader();
      
      return new Promise((resolve, reject) => {
        reader.onload = async (e) => {
          const base64 = e.target?.result?.split(',')[1];
          const fileType = file.type === 'application/pdf' ? 'pdf' : 'image';

          try {
            const response = await axios.post(`${API}/ocr/extract`, {
              image_base64: base64,
              document_type: docType,
              file_type: fileType,
            });

            if (response.data.suggestions) {
              toast.success(`Data extracted from ${docType}`);
              resolve(response.data.suggestions);
            } else {
              toast.warning('Unable to extract data. Please enter manually.');
              resolve(null);
            }
          } catch (error) {
            toast.error('OCR extraction failed. Please enter manually.');
            reject(error);
          } finally {
            setLoading(false);
          }
        };
        
        reader.onerror = () => {
          toast.error('Failed to read file');
          setLoading(false);
          reject(new Error('File read error'));
        };
        
        reader.readAsDataURL(file);
      });
    } catch (error) {
      toast.error('Failed to process file');
      setLoading(false);
      return null;
    }
  }, []);

  return { extractData, loading };
};
